import { useEmitUserInteractionEvents as useEmitUserInteractionEventsObservability } from "@zapier/observability";
import { useAtomValue } from "jotai";
import { canvasAtom, sessionAtom } from "@zapier/canvas-state";
import { useCurrentAccountId } from "@zapier/identity";

export function useEmitUserInteractionEvents() {
  const canvas = useAtomValue(canvasAtom);
  const session = useAtomValue(sessionAtom);
  const currentAccountId = useCurrentAccountId();

  return useEmitUserInteractionEventsObservability({
    canvasId: canvas.id,
    sessionId: session?.id,
    currentAccountId: currentAccountId,
  });
}
